// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateUserFeedbackMutationVariables = Types.Exact<{
  input: Types.CreateUserFeedbackInput;
}>;


export type CreateUserFeedbackMutation = { __typename?: 'Mutation', createUserFeedback: { __typename?: 'UserFeedback', id: string, feedback: string, feedbackCategory: Types.UserFeedbackFeedbackCategory, entity?: { __typename?: 'Entity', id: string } | null, household: { __typename?: 'Household', id: string } } };

export const Operations = {
  Mutation: {
    CreateUserFeedback: 'CreateUserFeedback' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const CreateUserFeedbackDocument = gql`
    mutation CreateUserFeedback($input: CreateUserFeedbackInput!) {
  createUserFeedback(input: $input) {
    id
    feedback
    feedbackCategory
    entity {
      id
    }
    household {
      id
    }
  }
}
    `;
export type CreateUserFeedbackMutationFn = Apollo.MutationFunction<CreateUserFeedbackMutation, CreateUserFeedbackMutationVariables>;

/**
 * __useCreateUserFeedbackMutation__
 *
 * To run a mutation, you first call `useCreateUserFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserFeedbackMutation, { data, loading, error }] = useCreateUserFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserFeedbackMutation, CreateUserFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserFeedbackMutation, CreateUserFeedbackMutationVariables>(CreateUserFeedbackDocument, options);
      }
export type CreateUserFeedbackMutationHookResult = ReturnType<typeof useCreateUserFeedbackMutation>;
export type CreateUserFeedbackMutationResult = Apollo.MutationResult<CreateUserFeedbackMutation>;
export type CreateUserFeedbackMutationOptions = Apollo.BaseMutationOptions<CreateUserFeedbackMutation, CreateUserFeedbackMutationVariables>;